import { Values } from '@srgssr/rio-common';
import { ReservedPageAndModuleId } from '@srgssr/rio-shared';

export const SIDE_MENU_WIDTH = 160;
export const SIDE_MENU_WIDTH_EXPANDED = SIDE_MENU_WIDTH + 260;

const MARGIN = 20;
export const SIDE_MENU_MARGIN_LEFT = SIDE_MENU_WIDTH + MARGIN;
export const SIDE_MENU_MARGIN_LEFT_EXPANDED = SIDE_MENU_WIDTH_EXPANDED + MARGIN;

export const SIDE_MENU_ROUTE_BY_PATH = {
  SEARCH: 'search',
  HOMEPAGE: ['', ReservedPageAndModuleId.HOMEPAGE],
  FICTION: 'fiction',
  DOCUMENTARY: 'documentary',
  ENTERTAINMENT: 'entertainment',
  MUSIC: 'music',
  CATEGORIES: 'themes',
  MY_LIST: 'my-list',
  SETTINGS: 'settings',
} as const;
export const SIDE_MENU_ROUTE_PATHS = Object.values(SIDE_MENU_ROUTE_BY_PATH);
export type SideMenuRoutePaths = Values<typeof SIDE_MENU_ROUTE_BY_PATH>;
